import React from "react";
import convertSecToTime from "../../Utils/convertSecToTime";
import { Button, Square } from "..";
import { RatingProps } from "./Rating.interface";
import styles from "./Rating.module.scss";
import { TypeSquare } from "../Square/Square.interface";
import { LS_CONFIG } from "../../Static/consts";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { setIsEnd, setIsResults } from "../../redux/slices/game/gameSlice";

export const Rating: React.FC<RatingProps> = (props) => {
  const { status, searchWord, time, onClose } = props;
  const { currentIndexWord, words } = useSelector(
    (state: RootState) => state.game
  );

  const dispatch = useDispatch();

  const onContinue = () => {
    localStorage.setItem(LS_CONFIG, JSON.stringify({ isFirstGame: false }));
    window.location.reload();
  };

  const onResults = () => {
    dispatch(setIsEnd(false));
    dispatch(setIsResults(true));
  };

  return (
    <div className={styles.rating}>
      <div className={styles.formClose} onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="none"
        >
          <path
            stroke="#000"
            strokeMiterlimit="10"
            strokeWidth="2"
            d="m4.757 4.757 8.486 8.486M4.757 13.243l8.486-8.486"
          />
        </svg>
      </div>
      <div className={styles.caption}>Вы {status}</div>
      <div className={styles.text} style={{ margin: "14px 0 10px 0" }}>
        Загаданное слово:
      </div>
      <div className={styles.word}>
        {searchWord.map((letter, id) => (
          <Square typeSquare={TypeSquare.ThisLetter} key={id} letter={letter} />
        ))}
      </div>
      <div className={styles.text} style={{ margin: "10px 0 14px 0" }}>
        Потраченное время: {convertSecToTime(time)}
      </div>
      {words && currentIndexWord < words.length - 1 ? (
        <Button title="Угадывать новое слово" onClick={onContinue} />
      ) : (
        <Button title="Посмотреть результаты" onClick={onResults} />
      )}
    </div>
  );
};
